import React from 'react';
import { Link } from 'react-router-dom';
import { EmptyList, EmptyPage } from '../../../assets/images';

type AppProps = {
  heading?: string;
  showAddButton?: boolean;
  imageWidth?: string;
  image?: any;
}

const EmptyDocumentData = ({ heading, showAddButton, imageWidth, image }: AppProps) => {
  return (
    <div>
      <h1 className="text-center">
        No Open Items Found!
      </h1>
      <div className="text-center">
        <span className="sub-text">{heading}</span>
        {showAddButton && <div className="mt-3">
          <Link className="btn btn-primary" to='/open-items-admin/add'>
            + Add Open Item
          </Link>
        </div>}
        <div className="text-center pl-5 ml-5">
          <img src={image ?? EmptyPage} style={{ width: imageWidth }} />
        </div>
      </div>
    </div>
  )
};

export default EmptyDocumentData;